// Loads a user's signature qualities, transparently switching between the
// direct-sign and regular endpoints, and falls back to SES-only when the
// backend is unavailable.
export default function useSignatureQualities() {
  const { $api } = useNuxtApp()
  const directSignStore = useDirectSignStore()
  const { directUserRepository } = useLegacyApi()

  async function loadSignatureQualities(
    fallback: SignatureQualityData
  ): Promise<{ signatureQualities: SignatureQualityData; isQualitiesUncertain: boolean }> {
    try {
      const signatureQualities = directSignStore.isDirectSign
        ? await directUserRepository.getSignatureQualities()
        : await $api('/api/users/me/signature-qualities')
      return { signatureQualities, isQualitiesUncertain: false }
    } catch {
      return {
        signatureQualities: {
          ...fallback,
          // SES should be available always, so we can use it as a fallback
          ses: { any: { quality: 'SES', legislation: 'ZERTES', provider: 'SKRIBBLE_SES' } },
        },
        isQualitiesUncertain: true,
      }
    }
  }

  return { loadSignatureQualities }
}
